/* FFG add-on recommendations: one list of up to 6 with options picked in the row, cart drawer rows,
   and the older two-section layout (kept so other templates keep working).
   Shoppers add parts, including ones with options, without leaving the page.
   Adds never open the cart drawer on their own. */
(() => {
  if (window.__ffgAddonsLoaded) return;
  window.__ffgAddonsLoaded = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents, cur) => {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || currency }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Cart refresh (Krown theme drawer), without opening the drawer ---------- */
  async function refreshThemeCart() {
    const form = document.getElementById('AjaxCartForm');
    if (!form) return;
    try {
      const doc = parse(await (await fetch(root + '?section_id=helper-cart')).text());
      const f = doc.getElementById('AjaxCartForm');
      const s = doc.getElementById('AjaxCartSubtotal');
      if (f) {
        form.innerHTML = f.innerHTML;
        if (typeof form.ajaxifyCartItems === 'function') form.ajaxifyCartItems();
      }
      const sub = document.getElementById('AjaxCartSubtotal');
      if (s && sub) sub.innerHTML = s.innerHTML;
      const count = form.querySelector('[data-cart-count]');
      const total = form.querySelector('[data-cart-total]');
      if (count) document.querySelectorAll('[data-header-cart-count]').forEach((el) => { el.textContent = count.textContent; });
      if (total) document.querySelectorAll('[data-header-cart-total]').forEach((el) => { el.textContent = total.textContent; });
    } catch (e) { /* best-effort */ }
  }

  /* ---------- Cart drawer: recommendation groups under each cart item, each with an open/close toggle ---------- */
  let slotTimer;
  const groupState = new Map(); /* line key -> open (true/false), remembered while the page is open */
  function setGroup(group, open) {
    const btn = group.querySelector('[data-ffg-group-toggle]');
    const body = group.querySelector('.ffg-cart-group__body');
    if (!btn || !body) return;
    body.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    group.classList.toggle('is-open', open);
  }
  async function loadCartAddons() {
    const form = document.getElementById('AjaxCartForm');
    if (!form) return;
    let slot = document.getElementById('ffg-cart-addons-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.id = 'ffg-cart-addons-slot';
      form.after(slot);
    }
    try {
      const doc = parse(await (await fetch(root + '?section_id=ffg-cart-addons')).text());
      const block = doc.querySelector('.ffg-cart-addons');
      const link = doc.querySelector('link[rel="stylesheet"]');
      document.querySelectorAll('.ffg-cart-group').forEach((g) => g.remove());
      slot.innerHTML = link ? link.outerHTML : '';
      if (!block) return;
      const many = Number(block.dataset.lines || 0) > 1;
      Array.from(block.querySelectorAll('.ffg-cart-group')).forEach((group) => {
        const key = group.dataset.ffgLine;
        const open = groupState.has(key) ? groupState.get(key) : !many;
        setGroup(group, open);
        let item = null;
        form.querySelectorAll('[data-js-cart-item]').forEach((el) => { if (el.dataset.id === key) item = el; });
        if (item) item.after(group); else slot.appendChild(group);
      });
    } catch (e) { /* best-effort */ }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ffg-group-toggle]');
    if (!btn) return;
    const group = btn.closest('.ffg-cart-group');
    if (!group) return;
    const open = btn.getAttribute('aria-expanded') !== 'true';
    setGroup(group, open);
    groupState.set(group.dataset.ffgLine, open);
  });
  function watchCart() {
    const form = document.getElementById('AjaxCartForm');
    if (!form) return;
    loadCartAddons();
    new MutationObserver(() => {
      clearTimeout(slotTimer);
      slotTimer = setTimeout(loadCartAddons, 250);
    }).observe(form, { childList: true });
  }

  /* ---------- Add to cart ---------- */
  function announce(variantIds, source, response) {
    const detail = { variantIds: variantIds.map(Number), source, response };
    document.dispatchEvent(new CustomEvent('ffg:cart-updated', { detail }));
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('ffg_addon_added', { source, variant_ids: detail.variantIds });
      }
    } catch (e) { /* best-effort */ }
    refreshThemeCart();
  }

  async function addItems(variantIds, source) {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: variantIds.map((id) => ({ id: Number(id), quantity: 1 })) })
    });
    if (!res.ok) {
      let message = 'Couldn\u2019t add to cart. Refresh the page and try again.';
      try { const err = await res.json(); if (err && err.description) message = err.description; } catch (e) { /* keep default */ }
      throw new Error(message);
    }
    const data = await res.json();
    announce(variantIds, source, data);
    return data;
  }

  const sourceOf = (el) => {
    const host = el.closest('[data-source]');
    return el.dataset.ffgSource || (host && host.dataset.source) || 'unknown';
  };
  const statusOf = (el) => {
    const scope = el.closest('ffg-recs, ffg-required-addons, ffg-build-carousel, .ffg-cart-group, .ffg-cart-addons');
    return scope && scope.querySelector('.ffg-msg');
  };
  function markAdded(btn, title) {
    btn.textContent = 'Added \u2713';
    btn.classList.add('is-added');
    btn.disabled = true;
    if (title) btn.setAttribute('aria-label', 'Added to cart: ' + title);
  }

  document.addEventListener('click', async (event) => {
    const addBtn = event.target.closest('[data-ffg-add]');
    if (addBtn && !addBtn.disabled) {
      const title = (addBtn.getAttribute('aria-label') || '').replace(/^Add to cart:\s*/, '');
      const status = statusOf(addBtn);
      const label = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.textContent = 'Adding\u2026';
      try {
        await addItems([addBtn.dataset.ffgAdd], sourceOf(addBtn));
        markAdded(addBtn, title);
        if (status) status.textContent = 'Added ' + title + ' to cart.';
      } catch (err) {
        addBtn.disabled = false;
        addBtn.textContent = label;
        if (status) status.textContent = err.message;
      } finally {
        addBtn.removeAttribute('aria-busy');
      }
      return;
    }
    const optBtn = event.target.closest('[data-ffg-options]');
    if (optBtn && !optBtn.disabled) {
      event.preventDefault();
      openSheet(optBtn.dataset.ffgOptions, optBtn);
    }
  });

  /* ---------- Options sheet (bottom sheet on phones, centered dialog on desktop) ---------- */
  let sheet = null;
  let state = null;

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'ffg-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="ffg-sheet__backdrop" data-ffg-close></div>' +
      '<div class="ffg-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="ffg-sheet-title">' +
        '<div class="ffg-sheet__head">' +
          '<h2 class="ffg-h ffg-h--sm" id="ffg-sheet-title"></h2>' +
          '<button type="button" class="ffg-sheet__close" data-ffg-close aria-label="Close">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>' +
          '</button>' +
        '</div>' +
        '<div class="ffg-sheet__body"></div>' +
        '<div class="ffg-sheet__foot">' +
          '<span class="ffg-sheet__price"></span>' +
          '<button type="button" class="ffg-btn ffg-sheet__add" disabled>Add to cart</button>' +
        '</div>' +
        '<p class="ffg-msg" role="status" aria-live="polite"></p>' +
        '<a class="ffg-sheet__link" href="#">View full details</a>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', (e) => { if (e.target.closest('[data-ffg-close]')) closeSheet(); });
    sheet.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(); }
      if (e.key === 'Tab') trapFocus(e);
    });
    sheet.querySelector('.ffg-sheet__body').addEventListener('change', updateVariant);
    sheet.querySelector('.ffg-sheet__add').addEventListener('click', addFromSheet);
  }

  function trapFocus(e) {
    const items = Array.from(sheet.querySelectorAll('.ffg-sheet__panel button:not([disabled]), .ffg-sheet__panel select, .ffg-sheet__panel a[href]'));
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  async function openSheet(handle, origin) {
    if (!sheet) buildSheet();
    state = { origin, product: null, variant: null };
    const title = sheet.querySelector('#ffg-sheet-title');
    const body = sheet.querySelector('.ffg-sheet__body');
    const add = sheet.querySelector('.ffg-sheet__add');
    title.textContent = 'Loading options\u2026';
    body.innerHTML = '';
    sheet.querySelector('.ffg-sheet__price').textContent = '';
    sheet.querySelector('.ffg-msg').textContent = '';
    add.disabled = true;
    add.textContent = 'Add to cart';
    sheet.querySelector('.ffg-sheet__link').href = root + 'products/' + encodeURIComponent(handle);
    sheet.hidden = false;
    document.documentElement.classList.add('ffg-lock');
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    sheet.querySelector('.ffg-sheet__close').focus();
    try {
      const res = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('load');
      const p = await res.json();
      state.product = p;
      title.textContent = p.title;
      const start = p.variants.find((v) => v.available) || p.variants[0];
      body.innerHTML = p.options.map((o, i) => {
        const name = typeof o === 'string' ? o : o.name;
        const values = (typeof o === 'string' || !o.values) ? Array.from(new Set(p.variants.map((v) => v.options[i]))) : o.values;
        const opts = values.map((v) => '<option value="' + esc(v) + '"' + (v === start.options[i] ? ' selected' : '') + '>' + esc(v) + '</option>').join('');
        return '<label class="ffg-field"><span>' + esc(name) + '</span><select data-index="' + i + '">' + opts + '</select></label>';
      }).join('');
      updateVariant();
      const firstSelect = body.querySelector('select');
      if (firstSelect) firstSelect.focus();
    } catch (e) {
      title.textContent = 'Options unavailable';
      body.innerHTML = '<p class="ffg-sub">Open the product page to choose options.</p>';
    }
  }

  function updateVariant() {
    if (!state || !state.product) return;
    const picks = Array.from(sheet.querySelectorAll('.ffg-sheet__body select')).map((s) => s.value);
    const v = state.product.variants.find((x) => x.options.every((val, i) => val === picks[i]));
    state.variant = v || null;
    const add = sheet.querySelector('.ffg-sheet__add');
    const price = sheet.querySelector('.ffg-sheet__price');
    if (!v) { add.disabled = true; add.textContent = 'Not available'; price.textContent = ''; return; }
    price.textContent = money(v.price);
    add.disabled = !v.available;
    add.textContent = v.available ? 'Add to cart' : 'Sold out';
  }

  async function addFromSheet() {
    if (!state || !state.variant) return;
    const add = sheet.querySelector('.ffg-sheet__add');
    const msg = sheet.querySelector('.ffg-msg');
    add.disabled = true;
    add.textContent = 'Adding\u2026';
    try {
      await addItems([state.variant.id], sourceOf(state.origin));
      const label = state.product.title + (state.variant.title && state.variant.title !== 'Default Title' ? ' (' + state.variant.title + ')' : '');
      markAdded(state.origin, label);
      const status = statusOf(state.origin);
      if (status) status.textContent = 'Added ' + label + ' to cart.';
      closeSheet();
    } catch (err) {
      msg.textContent = err.message;
      updateVariant();
    }
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('ffg-lock');
    const origin = state && state.origin;
    setTimeout(() => { sheet.hidden = true; }, 250);
    if (origin && document.contains(origin)) origin.focus();
  }

  /* ---------- "Needed for installation": checkboxes + one combined button ---------- */
  class FfgRequiredAddons extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.button = this.querySelector('.ffg-req__add');
      this.status = this.querySelector('.ffg-msg');
      this.currency = this.dataset.currency;
      this.added = 0;
      this.addEventListener('change', (e) => {
        if (e.target.matches('.ffg-check')) { this.added = 0; this.render(); }
      });
      this.button.addEventListener('click', () => this.add());
      this.render();
    }
    selected() { return Array.from(this.querySelectorAll('.ffg-check:checked')); }
    render() {
      const checks = this.querySelectorAll('.ffg-check');
      this.button.hidden = checks.length === 0;
      if (!checks.length) return;
      this.button.classList.toggle('is-added', this.added > 0);
      if (this.added > 0) {
        this.button.disabled = true;
        this.button.textContent = 'Added ' + this.added + ' to cart \u2713';
        return;
      }
      const picked = this.selected();
      const total = picked.reduce((sum, el) => sum + Number(el.dataset.price || 0), 0);
      this.button.disabled = picked.length === 0;
      this.button.textContent = picked.length
        ? 'Add ' + picked.length + ' selected \u00b7 ' + money(total, this.currency)
        : 'Select parts to add';
    }
    async add() {
      const picked = this.selected();
      if (!picked.length) return;
      this.button.disabled = true;
      this.button.textContent = 'Adding\u2026';
      try {
        await addItems(picked.map((el) => el.value), this.dataset.source || 'pdp_required');
        this.added = picked.length;
        this.status.textContent = 'Added ' + picked.length + (picked.length === 1 ? ' part' : ' parts') + ' to cart.';
      } catch (err) {
        this.status.textContent = err.message;
      }
      this.render();
    }
  }

  /* ---------- "Nice add-ons": loads Shopify complementary products when no list is set ---------- */
  class FfgBuildCarousel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const url = this.dataset.fetchUrl;
      if (!url) return;
      const load = async () => {
        try {
          const doc = parse(await (await fetch(url)).text());
          const track = doc.querySelector('[data-ffg-track]');
          if (!track || !track.querySelector('.ffg-row')) { this.remove(); return; }
          this.querySelector('[data-ffg-track]').innerHTML = track.innerHTML;
          this.classList.remove('ffg-is-loading');
        } catch (e) { this.remove(); }
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) { io.disconnect(); load(); }
        }, { rootMargin: '600px 0px' });
        io.observe(this);
      } else {
        load();
      }
    }
  }


  /* ---------- Options picked inside the row (no popups, no page change) ---------- */
  const shorten = (t) => (t.length > 28 ? t.slice(0, 27).trim() + '\u2026' : t);
  function picker(row) {
    const data = row.querySelector('[data-ffg-variants]');
    let variants = [];
    try { variants = data ? JSON.parse(data.textContent) : []; } catch (e) { variants = []; }
    const selects = Array.from(row.querySelectorAll('[data-ffg-opts] select'));
    const priceEls = Array.from(row.querySelectorAll('[data-ffg-price]'));
    const note = row.querySelector('[data-ffg-note]');
    const vals = () => selects.map((s) => s.value);
    function cascade() {
      selects.forEach((sel, i) => {
        const before = vals();
        let firstOk = null;
        Array.from(sel.options).forEach((opt) => {
          const ok = variants.some((v) => v.available && before.slice(0, i).every((val, j) => v.options[j] === val) && v.options[i] === opt.value);
          opt.disabled = !ok;
          if (ok && firstOk === null) firstOk = opt.value;
        });
        const chosen = sel.options[sel.selectedIndex];
        if (chosen && chosen.disabled && firstOk !== null) sel.value = firstOk;
      });
    }
    function current() {
      if (!selects.length) return variants.find((v) => v.available) || variants[0] || null;
      const picked = vals();
      return variants.find((v) => v.options.every((val, i) => val === picked[i])) || null;
    }
    function refresh(showPrice) {
      cascade();
      const v = current();
      if (selects.length && showPrice) {
        if (v && v.available) {
          priceEls.forEach((el) => { el.textContent = money(v.price); });
          if (note) note.textContent = '';
        } else if (note) {
          note.textContent = 'That combination isn\u2019t available. Try another option.';
        }
      }
      return v;
    }
    selects.forEach((s) => s.addEventListener('change', () => {
      refresh(true);
      row.dispatchEvent(new CustomEvent('ffg:pick', { bubbles: true }));
    }));
    cascade();
    return { current, refresh, hasOptions: selects.length > 0 };
  }

  /* ---------- Recommended cards: every card adds straight to the cart ---------- */
  class FfgRecs extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.msg = this.querySelector('.ffg-grid__status') || this.querySelector('.ffg-msg');
      this.rows = Array.from(this.querySelectorAll('[data-ffg-item]')).map((row) => ({
        row,
        opts: row.querySelector('[data-ffg-opts]'),
        toggle: row.querySelector('[data-ffg-opttoggle]'),
        addBtn: row.querySelector('[data-ffg-addtoggle]'),
        optAdd: row.querySelector('[data-ffg-optadd]'),
        inCart: false,
        p: picker(row),
        title: (row.querySelector('.ffg-title') || {}).textContent ? row.querySelector('.ffg-title').textContent.trim() : 'this part'
      }));
      /* On phones (2 small cards per slide) the options panel moves to a holder under the carousel */
      const holder = this.querySelector('[data-ffg-optholder]');
      const mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
      const setOpen = this.setOpen = (r, open) => {
        if (!r.opts) return;
        if (open && holder && mq && mq.matches) {
          this.rows.forEach((o) => { if (o !== r && o.opts && !o.opts.hidden) this.setOpen(o, false); });
          holder.appendChild(r.opts);
          r.row.classList.add('is-editing');
        } else if (!open && holder && r.opts.parentElement === holder) {
          if (r.toggle) r.toggle.after(r.opts); else r.row.appendChild(r.opts);
          r.row.classList.remove('is-editing');
        }
        r.opts.hidden = !open;
        if (open && holder && r.opts.parentElement === holder) {
          const reduceM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          requestAnimationFrame(() => r.opts.scrollIntoView({ behavior: reduceM ? 'auto' : 'smooth', block: 'nearest' }));
        }
        const t = r.toggle;
        if (t) {
          t.setAttribute('aria-expanded', String(open));
          t.classList.toggle('is-open', open);
          const lbl = t.querySelector('[data-ffg-optlabel]');
          if (lbl) {
            if (!lbl.dataset.closed) lbl.dataset.closed = lbl.textContent;
            lbl.textContent = open ? 'Hide options' : (r.inCart ? '\u2713 In cart' : lbl.dataset.closed);
            t.classList.toggle('is-chosen', !open && r.inCart);
          }
        }
        if (open) r.p.refresh(true);
      };
      const addRow = async (r, btn, doneLabel) => {
        const v = r.p.current();
        if (!v || !v.available) {
          const note = r.row.querySelector('[data-ffg-note]');
          if (note) note.textContent = 'That combination isn\u2019t available. Try another option.';
          return false;
        }
        const label = btn.textContent;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Adding\u2026';
        try {
          await addItems([v.id], this.dataset.source || 'pdp_recs');
          r.inCart = true;
          r.row.classList.add('is-added');
          if (this.msg) this.msg.textContent = 'Added ' + r.title + ' to your cart.';
          btn.textContent = doneLabel || label;
          return true;
        } catch (err) {
          if (this.msg) this.msg.textContent = err.message;
          btn.textContent = label;
          btn.disabled = false;
          return false;
        } finally {
          btn.removeAttribute('aria-busy');
        }
      };
      this.rows.forEach((r) => {
        /* "+ Add": straight to the cart */
        if (r.addBtn) r.addBtn.addEventListener('click', async () => {
          if (r.addBtn.disabled) return;
          const ok = await addRow(r, r.addBtn, '\u2713 In cart');
          if (ok) { r.addBtn.classList.add('is-on'); r.addBtn.setAttribute('aria-pressed', 'true'); }
        });
        /* "Choose options" opens the panel; "Add to cart" in the panel adds the chosen version */
        if (r.toggle) r.toggle.addEventListener('click', () => {
          const open = r.opts.hidden;
          setOpen(r, open);
          if (open) { const s = r.opts.querySelector('select'); if (s) s.focus({ preventScroll: true }); }
        });
        if (r.optAdd) r.optAdd.addEventListener('click', async () => {
          if (r.optAdd.disabled) return;
          const ok = await addRow(r, r.optAdd, 'Add to cart');
          r.optAdd.disabled = false;
          if (ok) { setOpen(r, false); if (r.toggle) r.toggle.focus({ preventScroll: true }); }
        });
        const close = r.opts ? r.opts.querySelector('[data-ffg-optclose]') : null;
        const closePanel = () => { setOpen(r, false); if (r.toggle) r.toggle.focus({ preventScroll: true }); };
        if (close) close.addEventListener('click', closePanel);
        if (r.opts) r.opts.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.preventDefault(); closePanel(); } });
      });
      this.setupCarousel();
    }
    /* Mobile carousel: "1\u20132 of 6" count and arrows. On desktop all cards fit, so the nav hides itself. */
    setupCarousel() {
      const track = this.querySelector('[data-ffg-track]');
      const count = this.querySelector('[data-ffg-count]');
      if (!track || !count) return;
      const prev = this.querySelector('[data-ffg-prev]');
      const next = this.querySelector('[data-ffg-next]');
      const nav = count.parentElement;
      const metrics = () => {
        const cards = Array.from(track.children);
        if (!cards.length) return null;
        const w = cards[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const per = Math.max(1, Math.round((track.clientWidth + gap) / (w + gap)));
        return { cards, w, gap, per };
      };
      const update = () => {
        const m = metrics();
        if (!m) return;
        const total = m.cards.length;
        const scrolls = track.scrollWidth > track.clientWidth + 2;
        nav.hidden = !scrolls;
        if (!scrolls) return;
        const first = Math.min(total - m.per, Math.max(0, Math.round(track.scrollLeft / (m.w + m.gap))));
        const last = Math.min(total, first + m.per);
        count.textContent = (first + 1) + (last > first + 1 ? '\u2013' + last : '') + ' of ' + total;
        if (prev) prev.disabled = first <= 0;
        if (next) next.disabled = last >= total;
      };
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const step = (dir) => {
        const m = metrics();
        if (m) track.scrollBy({ left: dir * m.per * (m.w + m.gap), behavior: reduce ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', () => step(-1));
      if (next) next.addEventListener('click', () => step(1));
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }

  /* ---------- Cart drawer rows: "Options" opens dropdowns inside the row ---------- */
  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-ffg-toggle]');
    if (toggle) {
      const row = toggle.closest('[data-ffg-quick]');
      const opts = row && row.querySelector('[data-ffg-opts]');
      if (!opts) return;
      if (!row._ffgPicker) row._ffgPicker = picker(row);
      const willOpen = opts.hidden;
      opts.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', String(willOpen));
      toggle.textContent = willOpen ? 'Close' : 'Options';
      if (willOpen) row._ffgPicker.refresh(true);
      return;
    }
    const addSel = event.target.closest('[data-ffg-add-selected]');
    if (addSel && !addSel.disabled) {
      const row = addSel.closest('[data-ffg-quick]');
      const p = row._ffgPicker || (row._ffgPicker = picker(row));
      const v = p.current();
      const status = statusOf(addSel);
      if (!v || !v.available) { if (status) status.textContent = 'Choose an available option first.'; return; }
      addSel.disabled = true;
      addSel.textContent = 'Adding\u2026';
      try {
        await addItems([v.id], sourceOf(addSel));
        markAdded(addSel);
        if (status) status.textContent = 'Added to cart.';
      } catch (err) {
        addSel.disabled = false;
        addSel.textContent = 'Add to cart';
        if (status) status.textContent = err.message;
      }
    }
  });
  document.addEventListener('ffg:pick', (e) => {
    const row = e.target.closest && e.target.closest('[data-ffg-quick]');
    if (!row) return;
    const btn = row.querySelector('[data-ffg-add-selected]');
    const v = row._ffgPicker && row._ffgPicker.current();
    if (btn && !btn.classList.contains('is-added')) btn.disabled = !(v && v.available);
  });

  /* ---------- In-page jump links (Recommended Parts button, details link): smooth scroll ---------- */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-ffg-jump]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const target = href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
    if (!target) return;
    e.preventDefault();
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    const h = target.querySelector('h2');
    if (h) setTimeout(() => h.focus({ preventScroll: true }), reduce ? 0 : 400);
  });

  if (!customElements.get('ffg-required-addons')) customElements.define('ffg-required-addons', FfgRequiredAddons);
  if (!customElements.get('ffg-build-carousel')) customElements.define('ffg-build-carousel', FfgBuildCarousel);
  if (!customElements.get('ffg-recs')) customElements.define('ffg-recs', FfgRecs);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
  else watchCart();
})();
